// The browser window's width, live. BL-2587: the lot drawer's overlay host (and
// the docked host outside the shell) clamps its width against it.

import { useSyncExternalStore } from 'react';

function subscribe(onChange: () => void): () => void {
  window.addEventListener('resize', onChange);
  return () => window.removeEventListener('resize', onChange);
}

/**
 * The window's inner width in px, re-read on every resize.
 *
 * @returns the width, or 0 on the server render and the hydration pass (callers
 *   treat 0 as "not measured yet")
 */
export function useWindowWidth(): number {
  return useSyncExternalStore(
    subscribe,
    () => window.innerWidth,
    () => 0,
  );
}
